import { Component, OnInit } from '@angular/core';
//import { CommonModule } from '@angular/common';
//import { FormsModule } from '@angular/forms';
import { ApiService } from 'src/app/services/api/api.service';
import { StateService } from 'src/app/services/state/state.service';
import { HelperService } from 'src/app/services/helper/helper.service';
//import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
// import { faCopyright } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
})
//standalone: true,
//imports: [CommonModule, FormsModule, FontAwesomeModule, ],
export class AuthenticationComponent implements OnInit {
  environment = environment;
  // faCopyright = faCopyright;
  constructor(
    /* reference to api service */ private api: ApiService,
    /* reference to state service */ private state: StateService,
    /* reference to helper service */ public helper: HelperService,
    private msalService: MsalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.msalService.instance.handleRedirectPromise().then(
      res => {
        let redirectUrl = sessionStorage.getItem('redirectUrl') ? sessionStorage.getItem('redirectUrl') : '/my-collections';
        if (res != null && res.account != null) {
          this.msalService.instance.setActiveAccount(res.account);
          this.router.navigateByUrl(redirectUrl);
          sessionStorage.removeItem('redirectUrl');
        }
      }
    )

    if(this.msalService.instance.getActiveAccount() !== null){
      this.router.navigateByUrl('/my-collections');
    }
  }
  login() {
    this.msalService.loginRedirect();
  }

  logout() {
    this.msalService.logout();
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getActiveAccount() != null;
  }
}
